import { useState } from 'react';
import { View, Text, Button, Flex, Spinner, Card } from '@smarterservices/smarter-ui';
import CONSTANTS from '../../../config/constants';

/**
 * LockdownToolCard — Provides a button to invoke the ExamLockdownAndStart extension action.
 *
 * Only rendered when the ExamLockdownAndStart journey step has NOT been completed yet.
 * Clicking the button invokes the extension action on the test taker's browser.
 *
 * @param {Object} props
 * @param {Function} props.onLockdownAndStart - Callback to invoke the ExamLockdownAndStart action
 * @returns {JSX.Element}
 */
function LockdownToolCard({ onLockdownAndStart }) {
  const [isInvoking, setIsInvoking] = useState(false);

  const handleClick = async () => {
    setIsInvoking(true);
    try {
      await onLockdownAndStart();
    } catch (e) {
      console.error('[RemoteControl] Lockdown and start failed:', e);
    } finally {
      setIsInvoking(false);
    }
  };

  // leave the card out of the DOM since the dialog handles this. But lets keep this incase we want to use it...
  return null;

  return (
    <Card margin="small none none none">
      <Card.Header
        background="brand"
        padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
      >
        <Card.Title>
          <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>
            Exam Lockdown
          </Text>
        </Card.Title>
      </Card.Header>
      <Card.Body padding={CONSTANTS.STYLES.CARD_BODY_PADDING}>
        <Text size="x-small">
          Lock down the exam browser and start the exam for the test taker.
        </Text>
        <View as="div" padding="small">
          <Button
            color="primary"
            display="block"
            onClick={handleClick}
            interaction={isInvoking ? 'disabled' : 'enabled'}
          >
            {isInvoking ? (
              <Flex alignItems="center" gap="x-small" justifyItems="center">
                <Spinner size="x-small" renderTitle="Starting lockdown" />
                <Text size="small">Starting...</Text>
              </Flex>
            ) : (
              'Lockdown & Start'
            )}
          </Button>
        </View>
      </Card.Body>
    </Card>
  );
}

export default LockdownToolCard;
